/* ORGANO/TYGRON site-wide glass redesign — scroll-reveal floor (v3, 2026-05-30)
   Runs on all templates. Skips the first section per page so above-the-fold
   primary content (hero / buy box / collection banner) is never hidden.
   Respects prefers-reduced-motion.

   v3: when the Framer-motion layer is active (<html class="rg-motion"> and
   motion is allowed), this script CEDES the reveal animation to redesign-motion.js
   (spring physics + stagger) and only hides the nodes to prevent FOUC. The
   IntersectionObserver path below stays as the guaranteed no-dependency FLOOR —
   it runs whenever motion is absent, fails to load, or reduced-motion is set.
   A head-inline watchdog calls window.__rgFloorReveal() if motion never boots. */
(function () {
  "use strict";

  // Standard templates use #MainContent; landing pages use <body class="lp-body">.
  var main = document.getElementById("MainContent");
  var lp = document.querySelector(".lp-body");
  var root = main || lp;
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var revealSections;
  if (main) {
    var sections = Array.prototype.slice.call(main.querySelectorAll(":scope > .shopify-section"));
    revealSections = sections.slice(1).filter(function (s) {
      // 2026-07-12 (design review A1): never animate a pinned scroll-scrub
      // section's wrapper — a transformed ancestor becomes the containing
      // block for position:sticky and breaks the stage's viewport pin.
      return !s.querySelector(".scrolly, [data-rg-no-reveal]");
    });
  } else {
    // landing page: reveal each LP section except the sticky header + first (hero)
    revealSections = Array.prototype.slice.call(
      lp.querySelectorAll(".lp-section--usp, .lp-section--mechanism, .lp-section--prodhero, .lp-section--dosage, .lp-section--founder, .lp-section--proof, .lp-section--pharma, .lp-section--testimonials, .lp-section--offer, .lp-section--risk, .lp-section--faq")
    );
  }

  var cards = Array.prototype.slice.call(root.querySelectorAll(
    ".organo-stats__card, .be-cta-card, .usp-card, .dosage-card, .testi-card, .organo-ladder__card"
  ));

  var nodes = revealSections.concat(cards);

  // stagger stat cards within their grid
  root.querySelectorAll(".organo-stats__grid").forEach(function (grid) {
    Array.prototype.slice.call(grid.querySelectorAll(".organo-stats__card")).forEach(function (card, i) {
      card.style.setProperty("--rg-i", i);
    });
  });

  // FLOOR reveal — CSS transition + IntersectionObserver. Always-works fallback.
  function floorReveal() {
    nodes.forEach(function (el) { el.classList.add("rg-reveal"); });
    if (reduce || !("IntersectionObserver" in window)) {
      nodes.forEach(function (el) { el.classList.add("rg-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("rg-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
    nodes.forEach(function (el) { io.observe(el); });
  }

  // Expose for the Framer-motion layer + its boot watchdog.
  window.__rgNodes = nodes;
  window.__rgFloorReveal = floorReveal;

  // If the motion layer is intended AND motion is allowed, cede reveals to it:
  // just hide the nodes (prevent FOUC); redesign-motion.js springs them in.
  if (document.documentElement.classList.contains("rg-motion") && !reduce) {
    nodes.forEach(function (el) { el.classList.add("rg-reveal"); });
    return;
  }

  floorReveal();
})();
